// Footer component
import { Logo } from './Logo';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getAnalyticsConsent, setAnalyticsConsent, trackExternalLink } from '../utils/analytics';

export function Footer() {
  const [analyticsEnabled, setAnalyticsEnabled] = useState(getAnalyticsConsent);

  const handleAnalyticsToggle = () => {
    const newConsent = !analyticsEnabled;
    setAnalyticsConsent(newConsent);
    setAnalyticsEnabled(newConsent);
  };

  return (
    <footer id="join" className="relative z-10 border-t border-zinc-800/60 bg-zinc-950 pointer-events-none" style={{ scrollMarginTop: '140px' }}>
      <div className="mx-auto max-w-7xl px-6 py-10 pointer-events-auto">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Join Info */}
          <div>
            <div className="flex items-center gap-3 mb-3">
              <Logo className="w-8 h-8" />
              <h3 className="text-xl font-bold">Find a Mesh Community</h3>
            </div>
            <p className="text-zinc-300 mb-4">
              Ready to get started? Find active Meshtastic communities around the world or start your own local network.
            </p>
            <a
              href="https://meshtastic.org/docs/community"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-400 text-zinc-900 font-semibold rounded-xl hover:bg-cyan-300 transition pointer-events-auto"
              onClick={() => trackExternalLink('meshtastic.org/docs/community', 'footer_cta')}
            >
              <span>Browse Communities</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-bold mb-3">Resources</h3>
            <ul className="space-y-2 text-zinc-400">
              <li>
                <a 
                  href="https://meshtastic.org/docs/introduction" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-cyan-400 transition pointer-events-auto flex items-center gap-2"
                >
                  <span className="text-cyan-400">📚</span>
                  Official Documentation
                </a>
              </li>
              <li>
                <a 
                  href="https://meshtastic.org/docs/hardware" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-cyan-400 transition pointer-events-auto flex items-center gap-2"
                >
                  <span className="text-cyan-400">🛠️</span>
                  Supported Hardware
                </a>
              </li>
              <li>
                <a 
                  href="https://meshtastic.org/docs/getting-started" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-cyan-400 transition pointer-events-auto flex items-center gap-2"
                >
                  <span className="text-cyan-400">🚀</span>
                  Getting Started Guide
                </a>
              </li>
              <li>
                <a 
                  href="https://discord.com/invite/ktMAKGBnBs" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-cyan-400 transition pointer-events-auto flex items-center gap-2"
                >
                  <span className="text-cyan-400">💬</span>
                  Official Discord Server
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-zinc-800 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-zinc-500">
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <p>
              Meshtastic® is a registered trademark. This site is an independent educational resource.
            </p>
            <button
              onClick={handleAnalyticsToggle}
              className="text-zinc-400 hover:text-zinc-300 transition-colors underline"
              title="Toggle anonymous usage analytics"
            >
              {analyticsEnabled ? 'Disable Analytics' : 'Enable Analytics'}
            </button>
          </div>
          <div className="flex items-center gap-3">
            <a href="https://github.com/meshtastic" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition pointer-events-auto">GitHub</a>
            <span>•</span>
            <a href="https://meshtastic.org/" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition pointer-events-auto">Meshtastic.org</a>
            <span>•</span>
            <Link to="/privacy" className="hover:text-cyan-400 transition pointer-events-auto">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
